"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallbackOnClose = void 0;
var _combobox = require("@reach/combobox");
var _usePrevious = require("../../../../hooks/usePrevious/usePrevious");
var _react = require("react");
var CallbackOnClose = function CallbackOnClose(_ref) {
  var callback = _ref.callback;
  var _useComboboxContext = (0, _combobox.useComboboxContext)(),
    isExpanded = _useComboboxContext.isExpanded;
  var previousIsExpanded = (0, _usePrevious.usePrevious)(isExpanded);
  (0, _react.useEffect)(function () {
    if (previousIsExpanded && !isExpanded) {
      callback();
    }
  }, [isExpanded, previousIsExpanded, callback]);
  return null;
};
exports.CallbackOnClose = CallbackOnClose;